import { and, hasType, or, schemaMatches } from '@jsonforms/core';
import { optionIs } from './optionIs';
export const isOneOfOptionMultiselect = and(optionIs('allOptionsResourceName'), or(schemaMatches((schema) => hasType(schema, 'array')), schemaMatches((schema) => schema.hasOwnProperty('oneOf') && schema.oneOf.some((s) => hasType(s, 'array')))));
